import React from 'react';
import "./footer.css";


const Footer = (props) => {
    return ( 
        <>
            <div className="footerBox">
                <div className="fCol1">
                    <img src="./assets/logo.png" className="fLogo" alt="Frankmierz"></img>
                </div>
                <div className="fCol2">
                    <h3>Few Thinking People Sp. z o. o.</h3>
                    <h5>support: <a href="mailto: it@ftpeople.pl">it@ftpeople.pl</a></h5>
                </div>
            </div>
        </>
     );
}
 
export default Footer;